import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Tasks = React.lazy(() => import('../pages/Hub/Tasks'));
const TasksApplication = React.lazy(() => import('../pages/Hub/TasksApplication'));
const TaskDetailsPage = React.lazy(() => import('../pages/Hub/TaskDetailsPage'));
const NewTask = React.lazy(() => import('../pages/Hub/NewTask'));

export const getHubRoutes = (loggedIn, hubUserLoggedIn, allowHub, loginRedirect, location) => [
  {
    path: '/hub',
    element: loggedIn && allowHub
      ? <Tasks />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'task-details',
        element: loggedIn && allowHub
          ? <TaskDetailsPage />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'new-task',
        element: loggedIn && allowHub
          ? <NewTask />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/hub-app',
    element: (loggedIn && allowHub) || hubUserLoggedIn
      ? <TasksApplication />
      : <Navigate to="/login-app" replace />,
    children: [
      {
        path: 'task-details',
        element: (loggedIn && allowHub) || hubUserLoggedIn
          ? <TaskDetailsPage />
          : <Navigate to="/login-app" replace />
      },
      {
        path: 'new-task',
        element: (loggedIn && allowHub) || hubUserLoggedIn
          ? <NewTask />
          : <Navigate to="/login-app" replace />
      }
    ]
  }
];

